<template>
  <div class="profile-view">
    <profile-profile
      :profile-id="resolvedProfileId"
      page
    />
  </div>
</template>

<script>
import ProfileProfile from '@/profiles/ProfileProfile';

export default {
  components: {
    ProfileProfile,
  },

  props: {
    profileId: String,
  },

  computed: {
    resolvedProfileId() {
      return this.profileId || this.$route?.params?.profileId || null;
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-view {
  @include container;
  flex: 1;
}
</style>
